// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

class CardDownloadPDFSuccess extends React.Component {
    render() {
        const { immCard, cardType } = this.props;
        const cardId = immCard.get('cardId');
        const title = (
            <FormattedText
                value="cardDownloadPDF-cardDownloadPDF_successTitle"
                injectedStrings={[cardType]}
            />
        );
        const goBackButtonLabel = (
            <FormattedText
                value="cardDownloadPDF-cardDownloadPDF_backToCard"
                injectedStrings={[immCard.getIn(['alias','current'])]}
            />
        );
        const goBackButton = {
            label: goBackButtonLabel,
            url: `/myprofile/cards/${cardId}/details`
        }

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardSuccess
                    successMessage={title}
                    mainButton={goBackButton}>
                    <section className="row">
                        <div className="col-xs-6 col-md-7">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-6 col-md-5">
                            <FormattedText
                                value="cardDownloadPDF-cardDownloadPDF_successMessage"
                                injectedStrings={[cardType]}
                            />
                        </div>
                    </section>
                </WizardSuccess>
            </div>
        )
    }
}

CardDownloadPDFSuccess.propTypes = {
    cardType: PropTypes.string.isRequired,
    immCard: PropTypes.object.isRequired
};

module.exports = CardDownloadPDFSuccess;
